// src/components/DownloadButton.js

import React, { useState } from "react";

import "./DownloadButton.css";

import { ReactComponent as DownloadIcon } from "assets/icons/download_icon.svg";
import { ReactComponent as CloseSymbol } from "assets/icons/close-symbol.svg";

const DownloadButton = ({ baseImageSrc, stickers }) => {
  const [mobileDownloadImg, setMobileDownloadImg] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => { setIsModalOpen(true); };
  const closeModal = () => { setIsModalOpen(false); };

  const handleDownloadImage = async () => {
    const polaroidContainer = document.querySelector(".image-container");
    if (!polaroidContainer) return;

    // * use this to help pad the placement of elements on the canvas - should match padding on .image-container
    const TOP_PADDING = 5;
    const SIDE_PADDING = 20;
    const BORDER_RADIUS = 10; // Set border radius for canvas and generated image
    const ICON_BORDER_WIDTH = 1; // Border width for the icon

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = polaroidContainer.offsetWidth;
    canvas.height = polaroidContainer.offsetHeight;

    const drawRoundedRect = (x, y, width, height, radius) => {
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + width - radius, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      ctx.lineTo(x + width, y + height - radius);
      ctx.quadraticCurveTo(
        x + width,
        y + height,
        x + width - radius,
        y + height
      );
      ctx.lineTo(x + radius, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
      ctx.lineTo(x, y + radius);
      ctx.quadraticCurveTo(x, y, x + radius, y);
      ctx.closePath();
    };

    // Draw the main image with border radius
    const drawMainImage = async (element, x, y, width, height, radius) => {
      return drawElement(element, x, y, width, height); // Updated to include width and height parameters
    };

    const drawElement = async (element, x, y) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
          ctx.drawImage(img, x, y, element.width, element.height);
          resolve();
        };
        img.onerror = () => {
          console.error("Failed to load image at " + element.src);
          reject();
        };
        img.src = element.src;
      });
    };

    // Draw the background and text label
    ctx.fillStyle = "#FFFFFF"; // Assuming white background
    //drawRoundedRect(ctx, 0, 0, canvas.width, canvas.height, BORDER_RADIUS); //draw a white background to get rounded corners

    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#2A2A2A"; //set text color

    const label = polaroidContainer.querySelector(".polaroid-label");
    if (label) {
      const x = canvas.width / 2 - label.offsetWidth / 2;
      const y = label.offsetHeight;

      const borderX = x;
      const borderY = y;

      const labelX = borderX;
      const labelY = borderY;

      await drawElement(
        label,
        labelX,
        labelY,
        label.offsetWidth,
        label.offsetHeight
      );
    }

    // Draw the main image
    const mainImage = polaroidContainer.querySelector(".generated-image");
    if (mainImage) {
      const x = SIDE_PADDING;
      const y = label.offsetHeight + TOP_PADDING * 2;
      const width = mainImage.offsetWidth;
      const height = mainImage.offsetHeight;
      await drawMainImage(mainImage, x, y, width, height, BORDER_RADIUS);
    }

    // Draw additional elements like icons and logos
    const doubleBorder = ICON_BORDER_WIDTH * 2;
    const icon = polaroidContainer.querySelector(".icon");
    if (icon) {
      const x = canvas.width - icon.offsetWidth - SIDE_PADDING - doubleBorder;
      const y = label.offsetHeight + TOP_PADDING * 2;
      //ctx.fillStyle = 'black';

      const borderX = x;
      const borderY = y;

      const iconX = borderX + doubleBorder;
      const iconY = borderY;

      //black border does not have round corners
      //drawRoundedRect(borderX, borderY, icon.offsetWidth + doubleBorder, icon.offsetHeight + doubleBorder, 0);
      //ctx.fill();
      await drawElement(
        icon,
        iconX,
        iconY,
        icon.offsetWidth,
        icon.offsetHeight
      );
    }

    const logo = polaroidContainer.querySelector(".logo");
    if (logo) {
      const x = SIDE_PADDING;
      //another magic number because i said so!
      const y = TOP_PADDING * 4 + label.offsetHeight + mainImage.offsetHeight;
      console.log("logo " + x + " - " + y);
      await drawElement(logo, x, y);
      console.log("finished");
    }

    // Draw stickers
    const stickers = polaroidContainer.querySelectorAll(".sticker");
    stickers.forEach(async (sticker) => {
      const style = sticker.currentStyle || window.getComputedStyle(sticker);
      const x = parseInt(style.left, 10);
      const y = parseInt(style.top, 10);
      await drawElement(sticker, x + 20, y + 20); //TODO: magic number = sticker offset
    });

    //need to wait for sticker images to load
    // ?wrapped this in a timeout because I dont want to deal with awaits
    setTimeout(() => {
      try {
        // Convert canvas to an image and trigger download
        canvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob);

          // check for mobile
          if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
            //set image url in modal and open it
            setMobileDownloadImg(url);
            openModal();
          } else {
            //desktop - we make a link and simulate a click to trigger the download
            const link = document.createElement("a");
            link.download = "custom-polaroid.png";
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          }
        }, "image/png");
      }
      catch (error) {
        console.error(error);
        alert("There was an error generating your image for download, please try again.");
      }

    }, "1000");
  };
  return (
    <>
      <a
        onClick={handleDownloadImage}
        className="primary button download data-gtm-downloadCard"
      >
        Download{" "}
        <span>
          <DownloadIcon />
        </span>
      </a>

      {isModalOpen && (
        <div className="download-modal-container">
          <div className="download-modal-overlay" onClick={closeModal}>
            <div className="download-modal-content" onClick={(e) => e.stopPropagation()}>
              <button onClick={closeModal} className="close-button">
                <CloseSymbol />
              </button>
              <div className="mobile-download-container">
                <h1>Download Image</h1>
                <img src={mobileDownloadImg} />
                <p>Long press the image to save to your photo album.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DownloadButton;
